<!--
    Styles
-->

<style>

    #app {
        height: 100vh;
        justify-content: space-between;
    }
    #app > .l-header {
        flex-shrink: 0;
        z-index: 2;
    }
    #app > .l-section {
        position: relative;
        z-index: 1;
    }
    #app > .l-footer {
        flex-shrink: 0;
    }
    #app > .l-popup {
        z-index: 3;
    }
    #app > .l-toasts {
        z-index: 4;
    }

</style>



<!--
    Template
-->

<template>
    <div id="app" class="u-col" v-if="exists || auth">
        <layout-header />
        <router-view class="l-section u-flex" />
        <layout-footer />
        <layout-popup />
        <layout-toasts />
    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapGetters, mapActions} from 'vuex'
    import layoutHeader from './header.vue'
    import layoutFooter from './footer.vue'
    import layoutPopup from './popup.vue'
    import layoutToasts from './toasts.vue'


    export default {

        components: {
            layoutHeader,
            layoutFooter,
            layoutPopup,
            layoutToasts
        },

        computed: {

            ...mapGetters('session', [
                'exists'
            ]),

            auth () {
                return this.$route.name === 'auth';
            }

        },

        methods: {

            ...mapActions('session', [
                'init'
            ])

        },

        created () {
            !this.auth && this.init();
        }

    }

</script>
